export const APP_CONSTANTS = {
    'bulkApproval': 'Bulk Approval',
    'EndUserSSApproved': 'End User SS Approved',
}
export const excludePath =['/admin/support-ticket-summary'] 